import { GridColDef } from "@mui/x-data-grid";
import { TbUser } from "react-icons/tb";

import DriverAvatar from "@/components/DriverAvatar";
import { TableHeader } from "@/components/TableHeader";
import { capitalizeWords } from "@/helpers/strings";
import { UserType } from "@/types/user.types";
import { WeTrackVehicleData } from "@/types/wetrack.types";

export const DriverColumn = (
    {
        avatar,
    }: {
        avatar?: boolean;
    } = { avatar: true }
): GridColDef<WeTrackVehicleData["properties"] & { userType: UserType }> => {
    return {
        field: "name",
        headerName: "activeDriver",
        minWidth: 230,
        flex: 0.6,
        valueGetter: (_value, row) => capitalizeWords(row.driver_name || row.name || ""),
        renderHeader: (params) => <TableHeader Component={TbUser} title={params.colDef.headerName!} />,
        renderCell: (params) => (
            <DriverAvatar
                avatar={!!avatar}
                userType={params.row.userType}
                isDeleted={params.row.isDeleted}
                name={params.row.driver_name || params.row.name || ""}
            />
        ),
    };
};
